import md5 from 'md5';
import { deviceDetect } from 'react-device-detect';
import tConfig from '@src/assets/ubit_tmp.mobileconfig';

export const getIP = async () => {
    return fetch('https://api-ipv4.ip.sb/geoip').then((res) => {
        return res.json();
    });
};

export const getFP = async (ip) => {
    let fpResult = '';

    const userAgent = navigator.userAgent;
    var info = deviceDetect(userAgent);

    // fpResult = info['vendor'] + info['model'] + info['os'] + info['osVersion'] + ip;
    fpResult = info['os'] + ip.ip;

    let src = fpResult;

    fpResult = md5(src);

    sessionStorage.setItem('fp', fpResult);
    if (window.FingerPrint) {
        window.FingerPrint.postMessage(fpResult);
    }

    return fpResult;
};

export const sendFp = async () => {
    let ip = await getIP();
    let fpResult = await getFP(ip);
    const params = new URLSearchParams(window.location.search).get('merchantCode');

    const url = 'https://mobile.affpstore.com:55001/register';

    const data = {
        appId: 'ubit',
        fp: fpResult,
        params,
    };

    console.log(`data = ${data.appId}, ${data.fp}, ${data.params}`);

    return fetch(url, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
        .then((res) => {
            return res.text();
        })
        .then((res) => {
            console.log('sendFp, result = ', res);
        })
        .catch((error) => {
            console.log('sendFp, error = ', error);
        })
        .finally(() => {});
};

export const handleDownloadPWA = (domain, isCn) => {
    fetch(tConfig)
        .then((res) => res.text())
        .then((text) => {
            const merchantCode = new URLSearchParams(window.location.search).get('merchantCode');
            let newPwaUrl = domain ? `${domain}` : 'https://www.ubtuser.com';
            newPwaUrl =
                merchantCode != null ? `${newPwaUrl}?merchantCode=${merchantCode}` : newPwaUrl;
            var newText = text.replace(
                '<string>https://www.ubit.tmp</string>',
                `<string>${newPwaUrl}</string>`,
            );
            newText = newText.replaceAll(
                '<string>AppNameTmp</string>',
                `<string>${isCn ? '优币' : 'UBIT'}</string>`,
            );
            const blob = new Blob([newText], { type: 'application/x-apple-aspen-config' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'ubit.mobileconfig';
            document.body.appendChild(link);
            link.dispatchEvent(
                new MouseEvent('click', { bubbles: true, cancelable: true, view: window }),
            );
            link.remove();
            window.URL.revokeObjectURL(link.href);
        })
        .catch((e) => {
            console.error(e);
        });
};
